import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=f797ea84&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=f797ea84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f797ea84",
  null
  
)

export default component.exports